import { RFYA_DISPERSION_METHOD_STRATEGY } from './rfya.constants';
import { RP_DISPERSION_METHOD_STRATEGY } from './rp.constants';

import { DispersionMethodStrategyType } from '../models';

export const dispersionMethodRegistryStrategy: {
  [key: string]: ({ injector }) => DispersionMethodStrategyType;
} = {
  RP: RP_DISPERSION_METHOD_STRATEGY,
  RFYA: RFYA_DISPERSION_METHOD_STRATEGY,
};
